import { cx } from 'cvb';
import PropTypes from 'prop-types';
import { dividerStyles } from './style';

const Divider = ({ className, variant }) => (
  <div className={cx('divider', variant && `divider--${variant}`, className)}>
    <style jsx>{dividerStyles}</style>
  </div>
);

Divider.defaultProps = {
  className: '',
  variant: null,
};

Divider.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(['thick', 'thin', 'dashed', 'dotted']),
};

export { Divider };
export default Divider;
